/**
 * Created by shakibuz.zaman on 4/28/2021.
 */
export const auditTrailMappingByToolId = {
  'dac6-library': true,
  'dac6-relevant-taxpayers': true,
  'country-intermediaries': true,
  'dac6-other-persons': true,
  'dac6-reporting-overview': true,
  'dac6-pre-arrangement': true,
  'dac6-arrangements': true,
  'dac6-transactions': true,
  'dac6-filing-manager': true,
  'generic-report': true,
  'transmissions': true,
  'dac6-summary-rules': true,
  'country-analysis': true,
  'dac6-reporting-logic': true,
  'dac6-hallmark-countries': true
};
